export const AUTOCOMPLETE_TYPE = 'autocomplete'
export const SELECT_TYPE = 'select'
export const INPUT_TYPE = 'input'
export const DATETIME_PICKER_TYPE = 'datetimePicker'
export const FILE_INPUT_TYPE = 'file'
export const W_TAX_CODE_FIELD = 'wTaxCodeField'
